import { z } from "zod";
import { JOB_OFFER_STATUSES } from "@/features/recruitment/offer-vocabulary";

/**
 * URL search params for `/$workspaceSlug/recruitment/offers`.
 *
 * The status filter lives in the URL rather than in `useState` (S3): "every
 * offer still awaiting an answer" is a link a recruiter sends their manager on
 * a Monday, and the back button should undo a filter rather than leave the
 * page.
 */
export const offersRouteSearchSchema = z
  .object({ status: z.enum(JOB_OFFER_STATUSES).optional() })
  .strict();

export type OffersRouteSearch = z.infer<typeof offersRouteSearchSchema>;
